import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { getDocs, orderBy, query, Timestamp, where, getCountFromServer } from 'firebase/firestore';
import { Button, MenuItem, TextField } from '@mui/material';
import { orderRef, } from '../../../../utils/collectionRefs';
import { Title } from '../../../../components/Title/Title';
import { Header } from '../../../../components/Header/Header';
import NumbersRoundedIcon from '@mui/icons-material/NumbersRounded';

import { QRCodeCanvas } from 'qrcode.react';
import { useReactToPrint } from 'react-to-print';
import { orderStatus } from '../../../../utils';
import BalanceCard from '../../../../components/BalanceCard/BalanceCard';
import { Loader } from './../../../../components/Loader/Loader';

const PrintableLabels = React.forwardRef(({ orders }, ref) => (
  <div ref={ref}>
    {orders?.map((order) => (
      <div
        key={order.id}
        style={{
          pageBreakAfter: 'always',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1cm',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        <div
          style={{
            width: '8cm',
            height: '6cm',
            border: '2px dashed #333',
            borderRadius: '10px',
            padding: '0.5cm',
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            position: 'relative',
            backgroundColor: '#fff',
          }}
        >
          <div>
            <p style={{ fontSize: '13px', margin: '0 0 6px' }}>
              <strong>Куда:</strong> {order?.addressTo?.cityName}
            </p>
            <p style={{ fontSize: '13px', margin: '0 0 6px' }}>
              <strong>Номер получателя:</strong> {order.receiverPhone}
            </p>
            <p style={{ fontSize: '13px', margin: '0 0 6px' }}>
              <strong>PID:</strong> {order.pid}
            </p>
            <p style={{ fontSize: '13px', margin: '0 0 6px' }}>
              <strong>Комментарий:</strong> {order?.comments || '--'}
            </p>
          </div>
          <div
            style={{
              position: 'absolute',
              bottom: '0cm',
              right: '0.5cm',
            }}
          >
            <QRCodeCanvas value={order.pid} size={70} />
          </div>
        </div>
      </div>
    ))}
  </div>
));

const PrintOrders = ({ pageTitle }) => {
  const [orders, setOrders] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [loading, setLoading] = useState(true)
  const [selectedStatus, setSelectedStatus] = useState('status_on_courier');
  const [totalCount, setTotalCount] = useState(0);

  const printRef = useRef();

  useEffect(() => {
    let q = query(orderRef, where('status', '==', selectedStatus));

    if (selectedDate && selectedDate2) {
      const startOfDay = new Date(selectedDate);
      startOfDay.setHours(0, 0, 0, 0);
      const endOfDay = new Date(selectedDate2);
      endOfDay.setHours(23, 59, 59, 999);
      console.log(startOfDay, endOfDay)
      q = query(
        q,
        where('dateCreated', '>=', Timestamp.fromDate(startOfDay)),
        where('dateCreated', '<=', Timestamp.fromDate(endOfDay)),
        orderBy('dateCreated', 'desc')
      );

    }

    if (!selectedDate && !selectedDate2) {
      q = query(q, orderBy('dateCreated', 'desc'));
    }

    const fetchData = async () => {
      try {
        setLoading(true)
        const countSnapshot = await getCountFromServer(q);
        setTotalCount(countSnapshot.data().count);
        const querySnapshot = await getDocs(q);
        const newOrders = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        setOrders(newOrders);
        setLoading(false)

      } catch (error) {
        console.error('Error fetching orders:', error);
        setLoading(false)
      }
    };

    fetchData();
  }, [selectedDate, selectedDate2, selectedStatus]);

  const handleDateChange1 = (e) => handleDateChange('selectedDate', e.target.value);
  const handleDateChange2 = (e) => handleDateChange('selectedDate2', e.target.value);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const handleDateChange = (field, value) => {
    if (field === 'selectedDate') {
      setSelectedDate(value);
    } else if (field === 'selectedDate2') {
      setSelectedDate2(value);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Наклейки",
  });

  return (
    <div className="containerr">
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <Header previous="" initial={pageTitle} />
      <Title title={pageTitle} icon={<i className="icon-placeholder" />} />
      <div className='container-inner'>
        <BalanceCard
          title="Общее количество заказов"
          value={totalCount}
          icon={NumbersRoundedIcon}
          iconColor="#635BFF"
        />
        <div className='orders-card-wrapper'>
          <div className='orders-card-header'>
            <div className='orders-card-parent'>
              <div className='orders-card-parent__btns'>
                <Button variant='black-contained' onClick={handlePrint}>Печать</Button>

                <TextField
                  type='date'
                  size='small'
                  focused
                  color='warning'
                  value={selectedDate || ''}
                  onChange={handleDateChange1}
                  label='Начало'
                />
                <TextField
                  type='date'
                  size='small'
                  focused
                  color='warning'
                  value={selectedDate2 || ''}
                  onChange={handleDateChange2}
                  label='Конец'
                />
                <TextField
                  select
                  label="Статус"
                  size="small"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  sx={{ minWidth: 160 }}
                  color="warning"
                >
                  {orderStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
          </div>
          {
            loading ? (
              <Loader />
            ) : (
              <>
                {orders?.length > 0 ? (
                  <PrintableLabels ref={printRef} orders={orders} />
                ) : (
                  <h1 style={{ textAlign: 'center', marginTop: '20px' }}>
                    <p>Нет доступных заказов</p>
                  </h1>
                )}
              </>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default PrintOrders;